import React, { useMemo, useState } from "react";
import { ChevronDown } from "lucide-react";
import { TASK_BOARD_COLUMNS, taskBoardColumnKey } from "../constants";
import { isOverdue } from "../utils/taskDates";
import { assigneeDisplayName } from "../utils/taskCardMeta";
import { TaskCardMeta } from "./TaskCardMeta";

const PAGE = 40;

const TaskMobileList = ({
    tasks = [],
    role = "admin",
    assignOptions = [],
    onView,
}) => {
    const isStaff = role === "staff";
    const [openKeys, setOpenKeys] = useState(() => {
        const initial = {};
        TASK_BOARD_COLUMNS.forEach((col) => {
            initial[col.key] = col.key !== "Completed";
        });
        return initial;
    });
    const [visibleByKey, setVisibleByKey] = useState({});

    const grouped = useMemo(() => {
        const map = {};
        TASK_BOARD_COLUMNS.forEach((col) => {
            map[col.key] = [];
        });
        tasks.forEach((task) => {
            const key = taskBoardColumnKey(task);
            if (!map[key]) map[key] = [];
            map[key].push(task);
        });
        return map;
    }, [tasks]);

    return (
        <div className="task-mobile-list" role="list">
            {TASK_BOARD_COLUMNS.map((column) => {
                const columnTasks = grouped[column.key] || [];
                const overdueCount = columnTasks.filter(isOverdue).length;
                const expanded = Boolean(openKeys[column.key]);
                const visibleCount = visibleByKey[column.key] || PAGE;
                const visibleTasks = expanded ? columnTasks.slice(0, visibleCount) : [];
                return (
                    <section
                        key={column.key}
                        className="task-mobile-list__section"
                        style={{ "--col-accent": column.accent }}
                    >
                        <button
                            type="button"
                            className="task-mobile-list__head"
                            aria-expanded={expanded}
                            onClick={() =>
                                setOpenKeys((prev) => ({ ...prev, [column.key]: !prev[column.key] }))
                            }
                        >
                            <span className="task-board__dot" />
                            <span className="task-mobile-list__title">{column.label}</span>
                            <span className="task-board__count">{columnTasks.length}</span>
                            {overdueCount > 0 && (
                                <span className="task-board__overdue-count">{overdueCount} overdue</span>
                            )}
                            <ChevronDown
                                size={16}
                                className={`task-board__collapse-icon ${expanded ? "" : "is-collapsed"}`}
                            />
                        </button>
                        {expanded && (
                            <div className="task-mobile-list__body">
                                {columnTasks.length === 0 && (
                                    <p className="task-board__empty">No tasks</p>
                                )}
                                {visibleTasks.map((task) => (
                                    <button
                                        key={task.id}
                                        type="button"
                                        className="task-board__card task-mobile-list__card"
                                        onClick={() => onView?.(task)}
                                    >
                                        <TaskCardMeta
                                            task={task}
                                            person={
                                                isStaff
                                                    ? null
                                                    : assigneeDisplayName(task, assignOptions)
                                            }
                                            isStaff={isStaff}
                                        />
                                    </button>
                                ))}
                                {columnTasks.length > visibleCount && (
                                    <button
                                        type="button"
                                        className="task-board__more"
                                        onClick={() =>
                                            setVisibleByKey((prev) => ({
                                                ...prev,
                                                [column.key]: visibleCount + PAGE,
                                            }))
                                        }
                                    >
                                        Show {columnTasks.length - visibleCount} more
                                    </button>
                                )}
                            </div>
                        )}
                    </section>
                );
            })}
        </div>
    );
};

export default TaskMobileList;
